
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCandidateProfileThunk,
  updateCandidateProfileThunk,
  uploadCandidateProfileVideoThunk,
} from "../store/candidateProfile.thunk";
import type { CandidateProfileData } from "../types/candidateProfile.types";

export default function useCandidateProfile() {
  const dispatch: any = useDispatch();

  const { data, loading, error, videoUploading, videoUploadError } =
    useSelector((state: any) => state.candidateProfile);

  useEffect(() => {
    dispatch(fetchCandidateProfileThunk());
  }, [dispatch]);

  const saveProfile = async (
    payload: Partial<
      Pick<
        CandidateProfileData,
        | "designation"
        | "phone"
        | "location"
        | "about"
        | "skills"
        | "experience"
        | "education"
      >
    >
  ) => {
    return dispatch(updateCandidateProfileThunk(payload)).unwrap();
  };

  const uploadVideo = async (file: File) => {
    return dispatch(uploadCandidateProfileVideoThunk(file)).unwrap();
  };

  return {
    profile: data,
    loading,
    error,
    saveProfile,
    uploadVideo,
    videoUploading,
    videoUploadError,
  };
}
